// Angular imports
import { Injectable } from '@angular/core';

// Import observable
import { BehaviorSubject, Observable, Subscriber } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ApplicationContextService {
    // This service uses a new class, derived from Observable
    // Imo this is unnecessary. And so is the abstraction into templated functions
    // Since the Observables that are used by this application are known design time,
    // I decided to convert this service, starting with the 'selectedLine' ContextValue
    // Since I am working on that. I plan to update all Observables over time

    // OLD
    private context: { [field: string]: ContextValue<any> } = {};

    constructor() { }

    /**
     * @deprecated Use state management instead. This class will be removed in the next version
     * @param field 
     * @param value 
     * @returns 
     */
    public set<T>(field: string, value: T): ContextValue<T> {
        if (!(field in this.context))
            this.context[field] = new ContextValue(value);
        else
            this.context[field].set(value);

        return this.context[field];
    }

    /**
     * @deprecated Use state management instead. This class will be removed in the next version
     * @param field 
     * @returns 
     */
    public get<T>(field: string): ContextValue<T> {
        if (!(field in this.context))
            this.context[field] = new ContextValue(null);

        return this.context[field];
    }
}

export class ContextValue<T> extends Observable<T> {
    private _value: T;
    private subscribers: Subscriber<T>[] = [];

    constructor(value: T) {
        super((subscriber) => {
            this.subscribers.push(subscriber);
        });

        this._value = value;
    }

    public set(value: T): this {
        // Assign the value
        this._value = value;

        // Call next on all subscribers
        this.subscribers.forEach(sub => sub.next(this._value));

        // Return instance of self for chaining
        return this;
    }

    public get value(): T {
        return this._value;
    }
}
